var integrations = (function($) {
	function init() {

	}

	return {
		init:init
	};
}(jQuery));

jQuery(document).ready(function($) {
	integrations.init();
});